import { v4 as uuidv4 } from 'uuid'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import merge from 'lodash/merge'

import { playerStoreKey, playerStoreKeys } from '../playerStore/playerStoreConstants'
import { readZustandLocalStorage, updateZustandLocalStorage } from '../localStorageUtils'
import { getInitLanguage, isBrowserTabDuplicated } from '../../utils'
import { playerStore } from '../playerStore'
import { casinoStore } from '../casinoStore'
import { casinoStoreKey } from '../casinoStore/casinoStoreConstants'

export const createBaseAppStore = config => {
  const getPlayerInitialData = () => {
    const preferredLanguageCode =
      readZustandLocalStorage(`${playerStoreKey}.${playerStoreKeys.loginUser.preferredLanguageCode}`) ||
      getInitLanguage()

    let activeTabId = ''

    if (!config.allowTabDuplication) {
      activeTabId = sessionStorage.getItem('activeTabId')

      if (!activeTabId || isBrowserTabDuplicated()) {
        activeTabId = uuidv4()
      }

      sessionStorage.setItem('activeTabId', activeTabId)
    }

    return {
      [playerStoreKeys.activeTabId]: activeTabId,
      [playerStoreKeys.loginUser]: { preferredLanguageCode }
    }
  }

  // call update local storage with version checking
  const zustandLocalStorage = updateZustandLocalStorage('', {}, true)

  const playerInitialData = getPlayerInitialData()

  return create(
    devtools(
      (...a) => ({
        ...playerStore(merge(zustandLocalStorage[playerStoreKey], playerInitialData), ...a),
        ...casinoStore(zustandLocalStorage[casinoStoreKey], ...a)
      }),
      { enabled: process.env.NODE_ENV !== 'production' }
    )
  )
}
